import { useParams } from "react-router-dom"
import MainLayout from "../../layouts/MainLayout/MainLayout"
import { useContext, useEffect, useState } from "react"
import AuthContext from "../../contexts/AuthContext"
import AppContext from "../../contexts/AppContext"
import { ERROR_HANDLER } from "../../utils/error-handler"
import showNotification from "../../utils/showNotification"
import axios from "axios"
import LibraryContentDetailModal from "../../features/Library/LibraryContentDetailModal"
import { Center, Loader } from "@mantine/core"
import moment from "moment"
import CourseClassHeaderNavigation from "../../components/CourseClassHeaderNavigation/CourseClassHeaderNavigation"
import LibraryResultModal from "../../features/Library/LibraryResultModal"


export default function ContentLibraryDetails() {
    const { contentId } = useParams()
    const { authToken } = useContext(AuthContext)
    const { currentUser } = useContext(AppContext)

    const [isResultModal, setIsResultModal] = useState({
        status: null,
        message: "",
    })

    const [state, setState] = useState({
        data: null,
        isLoading: false,
        error: ''
    })

    const handleDownload = async (contentId) => {
        if (!contentId) return null
        try {
            setState(prev => ({ ...prev, isLoading: true }))
            const { data } = await axios.put(`${process.env.REACT_APP_BACKEND_SERVER}campus/library/${contentId}`, {},
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${authToken}`,
                    },
                }

            )

            const CONTENT_URL = data.url

            if (CONTENT_URL) {
                window.open(CONTENT_URL, "_blank");
                showNotification({
                    color: "green",
                    status: "success",
                    title: "Tu contenido esta listo para ver.",
                    message: `Detalle: ${CONTENT_URL}`,
                    autoClose: 6000
                })
                setIsResultModal({
                    message: CONTENT_URL,
                    status: 'success'
                })
                //   setSelectedContent(null)
            }

        } catch (error) {
            console.log(error)
            showNotification({
                color: "red",
                status: "error",
                title: "Ha ocurrido un problema para mostrar el contenido.",
                message: `Detalle: ${error?.response?.data?.message || ERROR_HANDLER[error.request.status] || ERROR_HANDLER.defaultError}`,
                autoClose: 6000
            })
            if (error?.response?.data?.message) {
                setIsResultModal({
                    message: error?.response?.data?.message,
                    status: 'error'
                })
            }
        } finally {
            setState(prev => ({ ...prev, isLoading: false }))
        }
    }

    useEffect(() => {

        const getContent = async () => {

            try {
                setState(prev => ({ ...prev, isLoading: true }))
                const URL = `${process.env.REACT_APP_BACKEND_SERVER}campus/library/${contentId}`
                const { data } = await axios.get(URL, {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${authToken}`,
                    },
                })
                // add a visit to current content
                await axios.put(`${process.env.REACT_APP_BACKEND_SERVER}campus/library/${contentId}?isVisit=true`, {},
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${authToken}`,
                        },
                    }
                )

                setState(prev => ({ ...prev, data }))

            } catch (error) {
                showNotification({
                    color: "red",
                    status: "error",
                    title: "Ha ocurrido un problema al cargar el contenido.",
                    message: `Detalle: ${ERROR_HANDLER[error.request.status] || ERROR_HANDLER.defaultError}`,
                    autoClose: 12000
                });
                setState(prev => ({ ...prev, error: `${ERROR_HANDLER[error.request.status] || ERROR_HANDLER.defaultError}` }))
            } finally {
                setState(prev => ({ ...prev, isLoading: false }))
            }
        }
        getContent()
    }, [contentId, authToken])



    if (state.isLoading) return <MainLayout>
        <Center mih={'100vh'}><Loader /></Center>
    </MainLayout>

    if (state.error) return <MainLayout>
        <p>Ha ocurrido un error al cargar el contenido</p>
        <p>{state.error}</p>
    </MainLayout>

    const lastReset = moment(currentUser?.subscription?.free_content?.last_download_date);
    const now = moment();

    const IS_TIME_DIFF_AVAILABLE = now.diff(lastReset, "months") >= 1 && !currentUser?.subscription?.is_active;
    const HAS_DOWNLOAD_TRIES = currentUser?.subscription?.free_content?.free_download_available && !currentUser?.subscription?.is_active
    const IS_DOWNLOAD_BTN_DISABLED = currentUser?.subscription?.is_active
        ? false
        : !HAS_DOWNLOAD_TRIES || !IS_TIME_DIFF_AVAILABLE


    if (!state.isLoading && !state.error && state.data) return (
        < MainLayout>
            <section className="LibraryPage-main-container">
                <div style={{  width: "max-content", height: 'max-content' }}>
                    <CourseClassHeaderNavigation
                        btnText="Volver a biblioteca"
                    />
                </div>
                <LibraryContentDetailModal
                    HAS_DOWNLOAD_TRIES={HAS_DOWNLOAD_TRIES}
                    IS_DOWNLOAD_BTN_DISABLED={IS_DOWNLOAD_BTN_DISABLED}
                    IS_TIME_DIFF_AVAILABLE={IS_TIME_DIFF_AVAILABLE}
                    IS_ACTIVE={currentUser?.subscription?.is_active}
                    handleDownload={handleDownload}
                    isLoading={state.isLoading}
                    content={state.data}
                />
                {
                  (isResultModal?.status) &&
                  <LibraryResultModal
                     opened={isResultModal}
                     onClose={() => {
                        setIsResultModal({
                           message: "",
                           status: null
                        })
                     }}
                     setState={setIsResultModal}
                     state={isResultModal}
                  />
               }
            </section>
        </MainLayout>)
}